const PROD = false;   

function getAPIURL() {
    if (PROD) {
        return "https://budgeteer.x01r.xyz";
    }else{
        return "https://budgeteer.x01r.xyz"
    }
}

module.exports={
    getAPIURL
}